import { render, staticRenderFns } from "./AssessorManualDetail.vue?vue&type=template&id=090b4192&scoped=true&"
import script from "./AssessorManualDetail.vue?vue&type=script&lang=js&"
export * from "./AssessorManualDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssessorManualDetail.vue?vue&type=style&index=0&id=090b4192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b4192",
  null
  
)

export default component.exports